const { href } = window.location
if (href.indexOf('qa-mgr.give543.com') !== -1) {
  module.exports = {
    server: '//qa-api.give543.com',
    reqlApi: '/api/admin',
    frontEndUrl: 'https://qa.give543.com',
    uploadUrl: 'https://qa-api.give543.com/api/file/uploadImg',
    wmsUploadUrl: 'https://qa-api.give543.com/api/wms/file/uploadImage',
    host: '//qa-api.give543.com',
    mobileUrl: 'https://m.qa.give543.com',
    organizerMobileUrl: 'https://morg.qa.give543.com',
    hilifeUrl: 'https://ecservicedev.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  }
} else if (href.indexOf('give-circle.com') !== -1) {
  module.exports = {
    server: '//api.give543.com',
    reqlApi: '/api/admin',
    uploadUrl: '//api.give543.com/api/file/uploadImage',
    host: '//api.give543.com/',
    frontEndUrl: '//www.give-circle.com',
    mobileUrl: '//m.give-circle.com',
    hilifeUrl: 'https://ecservice.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  }
} else if (href.indexOf('give543.com') !== -1) {
  module.exports = {
    server: '//api.give543.com',
    reqlApi: '/api/admin',
    uploadUrl: '//api.give543.com/api/file/uploadImage',
    wmsUploadUrl: '//api.give543.com/api/wms/file/uploadImage',
    host: '//api.give543.com/',
    frontEndUrl: 'https://www.give-circle.com',
    mobileUrl: 'https://m.give-circle.com',
    organizerMobileUrl: 'https://m.org.give-circle.com',
    hilifeUrl: 'https://ecservice.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  }
} else {
  module.exports = {
    server: 'https://qa-api.give543.com',
    reqlApi: '/api/admin',
    frontEndUrl: 'https://qa.give543.com',
    uploadUrl: 'https://qa-api.give543.com/api/file/uploadImg',
    wmsUploadUrl: 'https://qa-api.give543.com/api/wms/file/uploadImage',
    host: '//qa-api.give543.com',
    mobileUrl: 'https://m.qa.give543.com',
    organizerMobileUrl: 'https://morg.qa.give543.com',
    hilifeUrl: 'https://ecservicedev.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  }
}



// WEBPACK FOOTER //
// ./src/utils/config.js